
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D0EFEC","d":"m20.975 9.668 5.382 12.741 12.741 5.383-12.74 5.382-5.383 12.74-5.382-12.74-12.741-5.382 12.74-5.383zM35.473 2.42l2.153 5.096 5.097 2.152-5.097 2.153-2.153 5.097-2.152-5.097-5.097-2.153 5.097-2.152z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-linejoin":"round","d":"m22.787 6.044 5.382 12.74 12.741 5.383-12.74 5.382-5.383 12.74-5.382-12.74-12.74-5.382 12.74-5.382z"}})])
          )
        }
      }
    